export const GET_CAR_MODEL = 'GET_CAR_MODEL'
export const GET_CAR_VERSION = 'GET_CAR_VERSION'